import HMR, { createDefaultRoutes, hmDevRoutes } from '@hatfieldmedia/hmcore'
import { setCdnUrl, setSeoConfig } from '@/composables'
import '@hatfieldmedia/hmcore/style.css'
import { createPinia } from 'pinia'
import 'virtual:image-meta' // Initialize image metadata from images.meta.json
import 'virtual:org-schema' // Initialize organization schema.org data from org.schema.json
import 'virtual:video-meta' // Initialize video metadata from videos.meta.json
import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import { routes } from './router/routes'

// Configure SEO defaults
// __SITE_BASE_URL__ is injected at build time by hmcore-deploy
declare const __SITE_BASE_URL__: string
const siteBaseUrl =
  typeof __SITE_BASE_URL__ !== 'undefined' ? __SITE_BASE_URL__ : 'https://www.sigsfederal.com'

setSeoConfig({
  baseUrl: siteBaseUrl,
  titleSuffix: ' | SIGS Federal',
  // A dedicated 1200x630 card rather than the logo itself: the raw mark is
  // 900x243 on transparency, and summary_large_image wants roughly 1.91:1
  // with an opaque background - transparency unfurls as black.
  defaultImage: '/og-default.png',
  twitterCard: 'summary_large_image',
})

// Configure CDN for media assets
// Resolved from (in priority order):
//   1. VITE_CDN_URL env var (set by hmcore-deploy at build time)
//   2. cdn_url in terraform/shared.tfvars (kept current by hmcore-deploy and
//      committed, so local dev needs no .env file)
const cdnUrl = import.meta.env.VITE_CDN_URL || ''
if (cdnUrl) {
  setCdnUrl(cdnUrl)
}

// Project routes plus hmcore's defaults. `routes` stays free of hmcore's routes
// so vite.config.ts can feed it to the sitemap without picking up the 404
// catch-all or the dev-only gallery.
//
// VITE_REDIRECT_404_TO_HOME is toggled in vite.config.ts; off means unknown
// URLs render hmcore's 404 page.
const allRoutes = [
  ...routes,
  ...(import.meta.env.DEV ? hmDevRoutes : []),
  ...createDefaultRoutes({
    redirectNotFoundToHome: import.meta.env.VITE_REDIRECT_404_TO_HOME === 'true',
  }),
]

// oxlint-disable-next-line no-unused-vars  - not using router and initialState in this callback, but keeping to show they can be used
export const createApp = ViteSSG(App, { routes: allRoutes }, ({ app, router, initialState }) => {
  const pinia = createPinia()
  app.use(HMR)
  app.use(pinia)
})
